const languageChangeAction = (lang) =>{
    return{
        type:"CHANGE_LANGUAGE",
        payload:lang
    }
}

export default languageChangeAction;